import { ApiError } from 'common/src/exceptions/ErrorHandling';

const formatErrorMessage = (message: string) =>
  message.charAt(0).toUpperCase() + message.slice(1);

export function formControlErrors(
  { getValues, setError },
  apiError: ApiError,
): void {
  const { error: errorMessage } = apiError;
  const fields = Object.keys(getValues());

  errorMessage.forEach(({ property, message }) => {
    if (fields.includes(property)) {
      setError(property as any, {
        message: formatErrorMessage(message),
        type: 'apiError',
      });
    }
  });
}
